import { render, staticRenderFns } from "./ForgotId.vue?vue&type=template&id=43db7c6f"
import script from "./ForgotId.vue?vue&type=script&lang=js"
export * from "./ForgotId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports